define('app/factories/dashboard_coupon_list_factory',['app/setup', 'app/views/dashboard_coupon_list_view'], function(takhfifan) {
  $('.tkh-dashboard-coupons-list-view').each(function () {
        new takhfifan.dashboardCouponListView({
          el: $(this),
          pagesCount: $(this).data("pagesCount"),
          page: $(this).data("page")
        });
      }, this);
    });
